// extracted by mini-css-extract-plugin
module.exports = {"card":"_2Ay2KCbL7ZEV_6hwfojFWt","image":"_2bnTTkoGTPD9iWR9vjyQ1S"};